import BasicButton from "components/General/BasicButton";
import { useNavigate } from "react-router-dom"
import ActionsLegend from "components/InfoTabs/ActionsLegend";
import BirdLegend from "components/InfoTabs/BirdLegend";
import LandLegend from "components/InfoTabs/LandLegend";
import TopologyLegend from "components/InfoTabs/TopologyLegend";
import WaterLevelLegend from "components/InfoTabs/WaterLevelLegend";

export default function Legend({mapMode, showBirds=false}:{mapMode:string, showBirds:boolean}) {
  return (
    <div className="h-full w-full border-y-2 border-black bg-[#BCB7A8] flex items-center justify-center">
      <div className="p-2">
        {mapMode === "land"  && <LandLegend />}
        {mapMode === "topo"  && <TopologyLegend />}
        {mapMode === "water" && <WaterLevelLegend />}
      </div>

      {showBirds && (
          <div className="p-2">
            <BirdLegend />
          </div>
        )}
    </div>
  )
}
